"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createKappaService = void 0;
const config_1 = require("./../../config");
const axiosInterceptors_1 = require("../../utils/axiosInterceptors");
const restify_1 = require("../../utils/restify");
function createKappaService({ env, baseUrl: overrideBaseUrl }) {
    const interceptors = {
        request: [axiosInterceptors_1.authRequestInterceptor],
        response: [axiosInterceptors_1.unauthorizedResponseInterceptor],
    };
    const baseURL = overrideBaseUrl || `${config_1.config.caipirinha[env]}/kappa`;
    const base = restify_1.restify(baseURL, interceptors);
    const kappaV2Base = base.one('v2');
    const kappaV3Base = base.one('v3');
    return {
        v2: {
            base: kappaV2Base,
            activities: kappaV2Base.one('activities'),
            uploads: kappaV2Base.one('uploads'),
            bot: kappaV2Base.one('bot'),
            items: kappaV2Base.one('items'),
            logs: kappaV2Base.one('logs'),
            overlays: kappaV2Base.one('overlays'),
            store: kappaV2Base.one('store'),
            tipping: kappaV2Base.one('tipping'),
            experiments: kappaV2Base.one('experiments'),
            tips: kappaV2Base.one('tips'),
            users: kappaV2Base.one('users'),
            channels: kappaV2Base.one('channels'),
            points: kappaV2Base.one('points'),
            loyalty: kappaV2Base.one('loyalty'),
            stats: kappaV2Base.one('stats'),
            sessions: kappaV2Base.one('sessions'),
            chatstats: kappaV2Base.one('chatstats'),
            songrequest: kappaV2Base.one('songrequest'),
            themes: kappaV2Base.one('themes'),
            ads: kappaV2Base.one('ads'),
            streams: kappaV2Base.one('streams'),
            speech: kappaV2Base.one('speech'),
            contests: kappaV2Base.one('contests'),
            kappagen: kappaV2Base.one('kappagen'),
            changelogs: kappaV2Base.one('changelogs'),
            events: kappaV2Base.one('events'),
            invite: kappaV2Base.one('invite'),
            emotes: kappaV2Base.one('emotes'),
            extralife: kappaV2Base.one('extralife'),
            tiltify: kappaV2Base.one('tiltify'),
            filters: kappaV2Base.one('filters'),
            twitter: kappaV2Base.one('twitter'),
            integrations: kappaV2Base.one('integrations'),
            widgets: kappaV2Base.one('widgets'),
            orders: kappaV2Base.one('orders'),
            partner: kappaV2Base.one('partner'),
            partnerships: kappaV2Base.one('partnerships'),
            socialmedia: kappaV2Base.one('socialmedia'),
            merch: kappaV2Base.one('merch'),
        },
        v3: {
            base: kappaV3Base,
            giveaways: kappaV3Base.one('giveaways'),
        },
    };
}
exports.createKappaService = createKappaService;
